import CodeLabOtherImage from "../../../assets/category/CODE-LAB-OTHER.png";
import Image3 from "../../../assets/hack-lab.png";
import Image4 from "../../../assets/hack-lab.png";
import Image5 from "../../../assets/hack-lab.png";
import Image6 from "../../../assets/hack-lab.png";
import Image7 from "../../../assets/hack-lab.png";
import Image8 from "../../../assets/hack-lab.png";
import Image9 from "../../../assets/hack-lab.png";

const data = [
  {
    id: 1,
    category: "other",
    image: CodeLabOtherImage,
    title: "感情分析AI LINE BOT",
    desc: "写真に写っている人の感情をAI分析します。",
    demo: "https://line.me/R/ti/p/%40751jjpre",
    github: "https://github.com/aazutaku",
    blog: "https://code-lab-128.com/ai-line-bot-aws-sam-lambda-rekognition/137/",
  },
  {
    id: 2,
    category: "other",
    image: CodeLabOtherImage,
    title: "Chat GPT LINE BOT",
    desc: "ChatGPTをLINEから利用できるようにしました。",
    demo: "https://line.me/R/ti/p/%40612axzqg",
    github: "https://github.com/aazutaku",
    blog: "https://code-lab-128.com/",
  },
  {
    id: 3,
    category: "frontend",
    image: Image3,
    title: "example1",
    desc: "example1",
    demo: "https://code-lab-128.com/",
    github: "https://github.com/aazutaku",
    blog: "https://code-lab-128.com/",
  },
  {
    id: 4,
    category: "uiux",
    image: Image4,
    title: "test uiux",
    desc: "continue...",
    demo: "https://code-lab-128.com/",
    github: "https://github.com/aazutaku",
    blog: "https://code-lab-128.com/",
  },
  {
    id: 5,
    category: "uiux",
    image: Image5,
    title: "test uiux",
    desc: "continue...",
    demo: "https://code-lab-128.com/",
    github: "https://github.com/aazutaku",
    blog: "https://code-lab-128.com/",
  },
  {
    id: 6,
    category: "frontend",
    image: Image6,
    title: "test frontend",
    desc: "continue...",
    demo: "https://code-lab-128.com/",
    github: "https://github.com/aazutaku",
    blog: "https://code-lab-128.com/",
  },
  {
    id: 7,
    category: "frontend",
    image: Image7,
    title: "test frontend",
    desc: "continue...",
    demo: "https://code-lab-128.com/",
    github: "https://github.com/aazutaku",
    blog: "https://code-lab-128.com/",
  },
  {
    id: 8,
    category: "backend",
    image: Image8,
    title: "test backend",
    desc: "continue...",
    demo: "https://code-lab-128.com/",
    github: "https://github.com/aazutaku",
    blog: "https://code-lab-128.com/",
  },
  {
    id: 9,
    category: "frontend",
    image: Image9,
    title: "test frontend",
    desc: "continue...",
    demo: "https://code-lab-128.com/",
    github: "https://github.com/aazutaku",
    blog: "https://code-lab-128.com/",
  },
];

export default data;
